import { Link } from "@tanstack/react-router";
import { Button } from "@better-bookkeeping/ui/button";
import { getFallbackRedirectUrl } from "@/lib/redirect-utils";
import { useRuntimeConfig } from "@/lib/runtime-config";

export function SignedInPanel({
  "data-testid": testId,
}: {
  /**
   * Caller-supplied — the gateway index and /security both render this, so
   * the id is scoped by whichever screen you landed on.
   */
  "data-testid"?: string;
} = {}) {
  const runtimeConfig = useRuntimeConfig();
  const fallbackRedirectUrl = getFallbackRedirectUrl(runtimeConfig);

  return (
    <div className="space-y-5 text-center" data-testid={testId}>
      <div className="space-y-1">
        <h2
          className="text-2xl font-semibold tracking-tight"
          data-testid={testId ? `${testId}-title` : undefined}
        >
          You're in.
        </h2>
        <p className="text-sm text-muted-foreground">Pick what's next.</p>
      </div>
      <div className="flex flex-col gap-2 pt-2">
        {/* asChild renders the anchor through Slot, which merges the two sets
            of props onto one DOM node — so the id is repeated deliberately
            rather than being ambiguous about which element carries it. */}
        <Button
          asChild
          className="w-full"
          data-testid={testId ? `${testId}-go-to-app-link` : undefined}
        >
          <a
            href={fallbackRedirectUrl}
            data-testid={testId ? `${testId}-go-to-app-link` : undefined}
          >
            Go to app
          </a>
        </Button>
        <Link
          to="/security"
          className="rounded-md border bg-card px-4 py-3 text-sm font-medium transition-colors hover:bg-muted/40"
          data-testid={testId ? `${testId}-security-link` : undefined}
        >
          Sign-in security
        </Link>
        <Link
          to="/sessions"
          className="rounded-md border bg-card px-4 py-3 text-sm font-medium transition-colors hover:bg-muted/40"
          data-testid={testId ? `${testId}-sessions-link` : undefined}
        >
          Where you're signed in
        </Link>
      </div>
    </div>
  );
}
